import axios from 'axios';
import toastr from 'toastr';

export const change_expired = async (initialState) => {
  const url = 'https://slot.tizeti.com/geniatechapi/index.php';

  // Create FormData instead of URLSearchParams
  const formData = new FormData();
  // Add each key-value pair to the FormData object
  Object.entries(initialState).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    // No need to specify Content-Type for FormData as it's set automatically
    const res = await axios.post(url, formData);
    if (res.data) {
      return res.data;
    }
  } catch (error) {
    toastr.error('Error fetching data');
  }
};
